module.exports = __webpack_public_path__ + "static/media/recruit_480_develop.2e7a4392.png";